// eslint-disable-next-line import/prefer-default-export
export function setAllows (state, value) {
    if (!state.allows) {
        state.allows = {};
    }
    state.allows = value;
}

export function setPortfolioId (state, value) {
    state.portfolioId = value;
}

export function setDisable (state, value) {
    state.disable = value;
}

export function setRole (state, value) {
    state.role = value;
}

export function setUserProject (state, value) {
    state.userProject = value;
}
